export default "__VITE_ASSET__b02c8c64__"